import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';

const FaqContainer = styled(Container)`
  background-color: #EADED0;
  padding: 3rem 1.5rem;
  text-align: center;
  color: #333;
  margin: 0 auto;
}
`;

const FaqRow = styled(Row)`
    padding: 0;
    margin-left: ${({ isMobile }) => (isMobile ? '0' : '9rem')};
`;

const FaqRows = styled(Row)`
    padding: 0;
    margin-left: ${({ isMobile }) => (isMobile ? '0' : '9rem')};
    justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'flex-start')};
`;

const LanguageButton = styled(Button)`
    width: 120px;
    margin-right: 1rem;
    font-size: 1.125rem;
    font-weight: bold;
    border-radius: 20px;
    background-color: #b01116;
    color: #ffff;
    border-color: #b01116;

    &:hover {
        background-color: #8b0f13;
        border-color: #8b0f13;
    }

    &.btn-outline-secondary {
        background-color: #bdd2e2;
        color: #ffff;
        border-color: #bdd2e2;
    }
`;

const LanguageLabel = styled.h4`
    font-size: 22px;
    color: #292561;
    margin-right: 3rem;
    font-family: Montserrat, sans-serif;
    text-align: ${({ isMobile }) => (isMobile ? 'center' : 'center')};
`;

const LanguageButtonWrapper = styled.div`
    display: flex;
    justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'flex-start')}; /* Center on mobile */
    margin-bottom: 2rem;
    margin-left: ${({ isMobile }) => (isMobile ? '0' : '10rem')}; /* Dynamic based on screen size */
`;

const QuestionList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  font-size: 34px
  line-height: 65px;
  text-align: left;
 font-family: Montserrat, sans-serif;
  font-weight: 500;
  margin-left: ${({ isMobile }) => (isMobile ? '0' : '9rem')}; /* Dynamic based on screen size */
`;

const QuestionItem = styled.li`
    margin-bottom: 1rem;
    font-style: Montserrat;
    font-weight: 500;
    cursor: pointer;
    color: #292561;
    font-family: Montserrat, sans-serif;
    display: flex;
    align-items: center;
    word-wrap: break-word;
    width: calc(100% - 3rem);
    padding-right: 8rem;

    @media (max-width: 768px) {
        padding: 0;
    }
`;

const Answer = styled.div`
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-size: 1.100rem;
    font-family: Montserrat, sans-serif;
    color: #292561;
    margin-top: 1rem;
    line-height: 1.8;
    text-align: left;
    word-wrap: break-word;
    width: calc(100% - 112px);
`;

const ArrowIcon = styled.span`
    color: #292561;
    margin-right: 10px;
    text-decoration-line: none;
    transition: transform 0.3s;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

const Line = styled.div`
    height: 1px;
    background-color: #625b71;
    margin: 0.5rem 0;
    margin-left: 20px;
    width: calc(100% - 147px);
    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
        height: 3px; /* Thicker line on mobile/tablet */
    }
`;

const Disclaimer = styled.div`
    color: black;
    font-size: 1.000rem;
    font-family: 'Montserrat', sans-serif;
    // margin-top: 4rem;
    text-align: justify;
    padding: 3rem 1.5rem;
    padding-right: 9rem;
    margin-left: ${({ isMobile }) => (isMobile ? '0' : '9rem')};
    @media (max-width: 768px) {
        text-align: center;
        margin-left: 0;
        padding: 0;
        margin-top: 22px;
    }
`;

const FAQ = () => {
    const [language, setLanguage] = useState('filipino');
    const [openQuestionIndex, setOpenQuestionIndex] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Set initial mobile state

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // Update mobile state based on window size
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize); // Listen to resize events
        return () => window.removeEventListener('resize', handleResize); // Clean up listener on unmount
    }, []);

    const toggleLanguage = (selectedLanguage) => {
        setLanguage(selectedLanguage);
    };

    const toggleQuestion = (index) => {
        setOpenQuestionIndex(index === openQuestionIndex ? null : index);
    };

    const filipinoQuestions = [
        {
            question: 'Bakit ko kailangang mag-avail ng Home Protection package?',
            answer: 'Ang inyong tahanan ang lugar kung saan pinakakampante ka at ang inyong pamilya. Ang pag-protekta ng tahanan mo ay makakatulong sa pag-iwas ng mga posibleng gastusin dulot ng mga hindi inaasahang sakuna – tulad ng sunog, baha, bagyo, at lindol. Sa tamang insurance coverage, hindi mo lang pinangangalagaan ang iyong investment sa bahay kundi pati na rin ang kaligtasan at kapakanan ng iyong pamilya.'
        },
        {
            question: 'Ano ang kino-cover ng Home Protection?',
            answer: (
                <div>
                    <p>
                        Bukod sa basic coverage para sa Fire and Lightning, narito ang mga iba pang sakunang sakop sa
                        policy:
                    </p>
                    <ol>
                        <li>Earthquake, Flood & Typhoon</li>
                        <li>Extended Cover (Smoke Damage, Falling Aircraft, Vehicle Impact and Explosion)</li>
                        <li>Riot Strikes, Malicious Damage</li>
                        <li>Spontaneous Combustion</li>
                        <li>Landslide</li>
                        <li>Robbery & Burglary whilst inside the declared properties</li>
                    </ol>
                    <br></br>
                    <p>May karagdagang benepisyo rin ang Home Protection:</p>
                    <ol>
                        <li>Home Assistance – limit of PHP 10,000 annual aggregate</li>
                        <li>
                            Rental Expense Reimbursement in case of fire occurrence up to PHP 50,000 aggregate in
                            addition to Material Damage Cover
                        </li>
                        <li>Fire Fighting Expense – PHP 25,000 annual aggregate</li>
                        <li>Temporary Removal – PHP 25,000 annual aggregate</li>
                        <li>Personal Liability – limit of PHP 5,000 annual aggregate.</li>
                    </ol>
                </div>
            )
        },
        {
            question: 'Magkano ang coverage ng Home Protection?',
            answer: 'Nagbibigay ang Home Protection ng coverage hanggang PHP 50,000.00 bilang yearly limit sakaling magkaroon ng damage o loss dahil sa mga sakunang sakop ng policy.'
        },
        {
            question: 'Ano ang sakop ng Home Protection?',
            answer: 'Sinasakop ng Home Protection ang iyong personal na gamit o mga bagay sa loob ng bahay tulad ng furniture at appliances. Hindi kasama ang pera, alahas, at mga works of art. Kasama ang mga building improvements o leasehold improvements na ginawa mo sa property.'
        },
        {
            question: 'Kailangan bang homeowner ako para maging eligible sa pagbili ng Home Protection?',
            answer: 'Oo, kinakailangan na homeowner ka para makabili ng Home Protection. Pero kung ikaw ay nangungupahan, maaari ka pa ring kumuha ng insurance para sa mga bagay na pag-aari mo sa loob ng bahay (tulad ng furniture at appliances), pati na rin ang mga upgrade or mga renovation na ginawa mo sa inuupahang property.'
        },
        {
            question: 'May insurance na ako para sa bahay ko. Pwede pa ba akong kumuha ng isa pa mula sa BPI MS?',
            answer: 'Oo, maaari ka pa ring kumuha ng isa pang insurance policy mula sa BPI MS kahit na mayroon ka nang existing policy mula sa ibang insurer. Pero, kapag ikaw ay magfa-file ng claim, sakop lang ng BPI MS ang aktwal na halaga ng mga damage na hindi pa nababayaran o nake-claim mula sa ibang insurer, alinsunod sa mga terms and conditions ng inyong policy.'
        },
        {
            question:
                'Lumipat ako ng bahay pagkatapos kong bilhin ang BPI MS Home Protection. Covered pa ba ang appliances at furniture ko?',
            answer: 'Sinasakop ng iyong Home Protection policy ang mga damage na nangyayari sa address na ibinigay at nirehistro mo sa amin noong binili mo ang policy. Kung lumipat ka sa bagong bahay, kailangan mong ipaalam sa inyong Home Credit Sales Associate ang iyong bagong address upang ma-update nina Home Credit at BPI MS ang iyong records at mailipat ang coverage sa bagong address. Sa ganitong paraan, mananatiling protektado ang iyong mga gamit, mananatiling valid ang inyong claim, at mas magiging maayos ang pag-proseso ng claims kung sakaling may mangyaring hindi inaasahan. '
        },
        {
            question: 'Ilang beses akong pwedeng mag-file ng claim?',
            answer: 'Walang limit sa kung ilang beses ka pwedeng mag-file. Pero, mako-cover ka lang ng Home Protection hanggang sa limit ng inyong policy. Kapag naubos na ang limit ng coverage, automatic matatapos ang inyong coverage. '
        },

        {
            question: 'Kailan ako pwedeng mag-renew ng policy? Pwede bang mag-renew nang maaga?',
            answer: (
                <div>
                    <p>
                        Maaaring mag-renew nang maaga ng policy 45 days bago ang expiry date. Ang effectivity ng policy
                        mo ay parehas ng expiry date para masigurado ang patuloy na proteksyon.
                    </p>
                    <ol>
                        <p>
                            Example: <br />
                            Start Date of Policy : Nov. 30, 2023,
                            <br />
                            Expiry Date of Policy: Nov. 30, 2024 <br />
                            <br />
                            Renewal Transaction Date: October 30, 2024 <br />
                            Effectivity Date of the Renewal: November 30, 2024 <br />
                            Expiry Date: November 30, 2025
                        </p>
                    </ol>
                </div>
            )
        },

        {
            question:
                'Kung ang policy mo ay expired na sa araw na mag-rerenew ka, maari mo pa rin ma-avail ang Home Protection. Ang effectivity ng policy mo ay magiging petsa ng application plus 1 day.',
            answer: (
                <div>
                    <ol>
                        <p>
                            Example: <br />
                            Effectivity Date of the Renewal: November 30, 2024 <br />
                            Date na ikaw ay Magre-renew ng policy: November 20, 2024 <br />
                            Effectivity Date of your New policy: November 21, 2024
                        </p>
                    </ol>
                </div>
            )
        }
    ];

    const englishQuestions = [
        {
            question: 'Why should I avail of the Home Protection package?',
            answer: 'Your home is where you and your family feel safest. Protecting the place that keeps you secure will shield you from financial burdens caused by uncontrolled external factors like fires, typhoons, floods and earthquakes. With the right insurance coverage, you’re not only safeguarding your residential investment but also ensuring the safety and well-being of your family.'
        },
        {
            question: 'What does Home Protection cover?',
            answer: (
                <div>
                    <p>
                        Aside from the basic coverage of Fire and Lightning, below are the other events covered in the
                        policy:{' '}
                    </p>
                    <ol style={{ marginBottom: '24px' }}>
                        <li>Earthquake, Flood & Typhoon </li>
                        <li>Extended Cover (Smoke Damage, Falling Aircraft, Vehicle Impact and Explosion)</li>
                        <li>Riot Strikes, Malicious Damage</li>
                        <li>Spontaneous Combustion</li>
                        <li>Landslide</li>
                        <li>Robbery & Burglary whilst inside the declared properties</li>
                    </ol>{' '}
                    <br />
                    <p>Home Protection comes with additional benefits: </p>
                    <ol>
                        <li>Home Assistance – limit of PHP 10,000 annual aggregate</li>
                        <li>
                            Rental Expense Reimbursement in case of fire occurrence up to PHP 50,000 aggregate in
                            addition to Material Damage Cover
                        </li>
                        <li>Fire Fighting Expense – PHP 25,000 annual aggregate</li>
                        <li>Temporary Removal – PHP 25,000 annual aggregate</li>
                        <li>Personal Liability – limit of PHP 5,000 annual aggregate.</li>
                    </ol>
                </div>
            )
        },
        {
            question: 'How much is the coverage for Home Protection?',
            answer: 'Home Protection provides coverage up to PHP 50,000.00 as a yearly limit in case of damage or loss due to the perils covered in the policy. '
        },
        // { question: 'What is included in Home Protection?', answer: ' Home Protection covers your personal belongings or contents inside the house, such as furniture and appliances. However, it does not cover cash, jewelry, and works of art. The policy also includes coverage for building improvements or leasehold improvements you’ve made to the property.' },
        {
            question: 'What is being covered under Home Protection?',
            answer: 'Home Protection covers your personal belongings or contents inside the house, such as furniture and appliances. However, it does not cover cash, jewelry, and works of art. The policy also includes coverage for building improvements or leasehold improvements you’ve made to the property.'
        },

        {
            question: 'Do I have to be a Homeowner to be eligible to buy Home Protection? ',
            answer: 'Ownership is a requirement to purchase Home Protection. But if you’re renting a place, you can still get insurance for the things you own inside (like your furniture and appliances), and even for upgrades or renovations you’ve made to the rented property.  '
        },
        {
            question: 'I have an existing insurance for my house. Can I still get another one from BPI MS?',
            answer: 'You may still secure another insurance policy from BPI MS even if you already have an existing policy with another insurer.  However, if you need to file a claim, BPI MS will only cover the actual amount of losses that have not yet been paid or claimed by the other insurer. This is subject to the terms and conditions of your policy'
        },
        {
            question:
                'I moved to a new home after I purchased BPI MS Home Protection. Are my appliances and furniture still covered?',
            answer: 'Your Home Protection policy covers damages incurred at the address you provided and registered with us at the time of purchase. If you move to a new home, please inform your Home Credit Sales Associate about your new address so that both Home Credit and BPI MS can update your records and transfer your coverage to the new address. This ensures that your belongings remain protected, your claim remains valid, and the claims process goes smoothly in case of any unfortunate events.'
        },

        // { question: 'How do I file a claim? ', answer: 'In case of a claim, you or your beneficiary may notify BPI MS Claims through homeprotectionclaims.bpims.com.' },
        {
            question: 'How many times can I file a claim?',
            answer: ' There is no limit to how many times you can file a claim.However, Home Protection will only cover you up to the limit of your policy once the amount limit of the coverage is exhausted, your coverage will automatically end. '
        },
        {
            question: ' When can I renew my policy? Is early renewal possible?',
            answer: (
                <di>
                    <p>
                        You can renew your policy as early as 45 days before the expiration date. The renewed policy
                        will take <br /> effect on the expiry date of your current coverage, ensuring seamless
                        protection without any overlap.
                    </p>
                    <ol>
                        Example: <br />
                        Start Date of Policy : Nov. 30, 2023 <br />
                        Expiry Date of Policy: Nov. 30, 2024 <br />
                        <br />
                        Renewal Transaction Date: October 30, 2024 <br />
                        Effectivity Date of the Renewal: November 30, 2024
                        <br />
                        Expiry Date: November 30, 2025
                    </ol>
                </di>
            )
        },
        {
            question:
                'If your policy is expired on the day that are you are transacting renewal, you may still avail of the Home Protection. Effectivity date of your policy will be the date of transaction plus 1 day. ',
            answer: (
                <di>
                    <ol>
                        Example: <br />
                        Effectivity Date of the Renewal: November 30, 2024 <br />
                        Renewal Transaction Date: November 20, 2024 <br />
                        Effectivity Date of your New policy: November 21, 2024
                    </ol>
                </di>
            )
        }
    ];

    const questions = language === 'filipino' ? filipinoQuestions : englishQuestions;

    return (
        <FaqContainer fluid>
            <FaqRow className="justify-content-start mb-3" isMobile={isMobile}>
                <Col xs="auto">
                    <h1
                        style={{
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            color: '#292561',
                            marginRight: isMobile ? '0' : '99px',
                            textAlign: 'left'
                        }}
                    >
                        Frequently Asked Questions
                    </h1>
                    <p style={{ fontSize: '1rem', color: '#1B1464', fontWeight: '500' }}>
                        {language === 'filipino'
                            ? 'Ang mga madalas na tinatanong tungkol sa Home Protection insurance'
                            : 'Ang mga madalas na tinatanong tungkol sa Home Protection insurance'}
                    </p>
                </Col>
            </FaqRow>
            <FaqRows className="mb-3" isMobile={isMobile}>
                <Col xs="auto">
                    <LanguageLabel>Wika/Language</LanguageLabel>
                </Col>
            </FaqRows>
            <LanguageButtonWrapper isMobile={isMobile}>
                <LanguageButton
                    variant={language === 'filipino' ? 'danger' : 'outline-secondary'}
                    onClick={() => toggleLanguage('filipino')}
                >
                    Filipino
                </LanguageButton>
                <LanguageButton
                    variant={language === 'english' ? 'danger' : 'outline-secondary'}
                    onClick={() => toggleLanguage('english')}
                >
                    English
                </LanguageButton>
            </LanguageButtonWrapper>

            <Row>
                <Col>
                    <QuestionList isMobile={isMobile}>
                        {questions.map((item, index) => (
                            <div key={index}>
                                <QuestionItem onClick={() => toggleQuestion(index)}>
                                    <ArrowIcon isOpen={openQuestionIndex === index}>&gt;</ArrowIcon> {item.question}
                                </QuestionItem>
                                {openQuestionIndex === index && <Answer>{item.answer}</Answer>}
                                {index !== questions.length - 1 && <Line />}
                            </div>
                        ))}
                    </QuestionList>
                </Col>
            </Row>

            <Disclaimer>
                Disclaimer: The FAQs found on this page are merely for informational purposes and are not to be taken as
                a contract of insurance. While all efforts were exhausted to ensure that the contents of these FAQs are
                accurate and up to date, the terms and conditions and clauses found in the actual insurance policy will
                always prevail.
            </Disclaimer>
        </FaqContainer>
    );
};

export default FAQ;
